import { navigatorLanguages } from '@/services/i18n';

if (!('Intl' in window)) {
  // @ts-expect-error Fallback for browsers that don't support Intl
  window.Intl = {};
}

if (!('ListFormat' in window.Intl)) {
  // @ts-expect-error Fallback for browsers that don't support Intl.ListFormat
  Intl.ListFormat = class {
    format(list: string[]) {
      return list.join(', ');
    }
  };
}

export const formatList = (list: string[], options?: Intl.ListFormatOptions) => {
  return new Intl.ListFormat(navigatorLanguages, options).format(list);
};

export const formatListWithMore = (list: string[], max: number) => {
  if (list.length <= max) {
    return list.join(', ');
  }

  return `${list.slice(0, max).join(', ')}, +${list.length - max}`;
};
